import { bus } from './event-bus.js';
import { store } from './state-store.js';

let parsedCompanions = [];

export function initVastXmlParser() {
  bus.on('ad:event', ({ type }) => {
    if (type === 'adtagloaded') {
      _parseCompanionMeta();
    }
  });

  bus.on('session:started', () => {
    parsedCompanions = [];
  });
}

export function getParsedCompanions() {
  return parsedCompanions;
}

async function _parseCompanionMeta() {
  let xmlText = null;

  if (store.state.rawXml) {
    xmlText = store.state.rawXml;
  } else if (store.state.adTagUrl) {
    try {
      const resp = await fetch(store.state.adTagUrl);
      if (resp.ok) xmlText = await resp.text();
    } catch {
      // CORS or network failure -- not critical
    }
  }

  if (!xmlText) {
    parsedCompanions = [];
    bus.emit('vast:companionsParsed', parsedCompanions);
    return;
  }

  try {
    const doc = new DOMParser().parseFromString(xmlText, 'text/xml');
    if (doc.querySelector('parsererror')) {
      parsedCompanions = [];
      bus.emit('vast:companionsParsed', parsedCompanions);
      return;
    }

    const companionEls = doc.getElementsByTagNameNS('*', 'Companion');
    parsedCompanions = Array.from(companionEls).map((el, index) => ({
      index,
      width: parseInt(el.getAttribute('width'), 10) || 0,
      height: parseInt(el.getAttribute('height'), 10) || 0,
      renderingMode: (el.getAttribute('renderingMode') || 'default').toLowerCase(),
      id: el.getAttribute('id') || null,
    }));

    const endCardCount = parsedCompanions.filter(c => c.renderingMode === 'end-card').length;
    if (endCardCount > 0) {
      console.log(`[VastXmlParser] Found ${endCardCount} end-card companion(s)`);
    } else {
      console.log('[VastXmlParser] No end-card companions in VAST');
    }

    bus.emit('vast:companionsParsed', parsedCompanions);
  } catch (e) {
    console.warn('[VastXmlParser] Error parsing VAST XML:', e);
    parsedCompanions = [];
    bus.emit('vast:companionsParsed', parsedCompanions);
  }
}
